/* ============================================================
   DEAD FLIGHT ARROWS — dfa-upsell-ajout.js
   Ajout au panier AJAX pour les cartes d'upsell de la fiche
   produit : on reste sur la page, confirmation sur le bouton,
   événement dfa:cart-updated pour le compteur d'entête.
   ============================================================ */
(function () {
  'use strict';

  class DfaUpsellAjout extends HTMLElement {
    connectedCallback() {
      this._surSoumission = this.surSoumission.bind(this);
      this.addEventListener('submit', this._surSoumission);
    }
    disconnectedCallback() {
      this.removeEventListener('submit', this._surSoumission);
      if (this._minuterie) clearTimeout(this._minuterie);
    }

    surSoumission(e) {
      e.preventDefault();
      var form = e.target;
      var bouton = form.querySelector('[data-upsell-bouton]');
      var erreur = form.querySelector('[data-upsell-erreur]');
      if (!bouton || bouton.disabled) return;

      var self = this;
      var libelleAjout = bouton.dataset.libelleAjout || bouton.textContent;
      var libelleSucces = bouton.dataset.libelleSucces || 'Ajouté ✓';

      bouton.disabled = true;
      bouton.classList.add('is-chargement');
      if (erreur) erreur.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw d; });
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (panier) {
          document.dispatchEvent(new CustomEvent('dfa:cart-updated', { detail: panier }));
          bouton.classList.remove('is-chargement');
          bouton.classList.add('is-succes');
          bouton.textContent = libelleSucces;
          self._minuterie = setTimeout(function () {
            bouton.classList.remove('is-succes');
            bouton.textContent = libelleAjout;
            bouton.disabled = false;
          }, 2200);
        })
        .catch(function (d) {
          bouton.classList.remove('is-chargement');
          bouton.disabled = false;
          if (erreur) {
            erreur.textContent = (d && d.description) || 'Impossible d\u2019ajouter au panier. R\u00e9essaie.';
            erreur.hidden = false;
          }
        });
    }
  }

  if (!customElements.get('dfa-upsell-ajout')) customElements.define('dfa-upsell-ajout', DfaUpsellAjout);
})();